/*
 * Email logs: query params and request bodies, pinned to email_enums.json
 * (request_fields_read/required) via requests.test.js.
 */
export const preview_params = (pay_month, teacher_uuid) => ({ pay_month, teacher_uuid });

export const text_params = (pay_month) => ({ pay_month });

// pay_month: null writes the default row (the "Save as default" checkbox); otherwise this month's row.
export const save_text_body = (pay_month, use_default, fields, client_request_id) => ({
  pay_month: use_default ? null : pay_month,
  greeting: fields.greeting.trim(),
  intro: fields.intro.trim(),
  footer: fields.footer.trim(),
  reason: fields.reason.trim(),
  client_request_id
});
